<template>
  <el-form class="el__form" ref="form" :model="form" :rules="rules">
    <el-form-item prop="phone">
      <el-input
        prefix-icon="el-icon-user"
        placeholder="请输入手机号码"
        v-model="form.phone"
      ></el-input>
    </el-form-item>
    <el-form-item prop="captchaCode">
      <el-input
        prefix-icon="el-icon-key"
        placeholder="请输入图片验证码"
        v-model="form.captchaCode"
        class="captcha__code"
      >
        <el-image
          slot="append"
          @click="getCaptchaCode"
          :src="form.captchaImg"
        ></el-image>
      </el-input>
    </el-form-item>
    <el-form-item prop="code">
      <el-input
        prefix-icon="el-icon-key"
        placeholder="请输入验证码"
        v-model="form.code"
      >
        <el-button
          slot="append"
          :disabled="sendDisabled"
          @click="getCode(form.phone, form.captchaCode)"
          >{{ smsText }}</el-button
        >
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button class="el__btn" @click="submit('form')">登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { checkMobile } from "@/utils/tools.js";
import { getCaptcha, getSms, loginBySms, getUserDeatil } from "@/api/outh";
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  data() {
    return {
      smsText: "发送验证码",
      sendDisabled: false,
      count: 60,
      timer: null,
      form: {
        phone: "",
        code: "",
        key: "",
        captchaCode: "",
        captchaKey: "",
        captchaImg: "",
      },
      rules: {
        phone: [{ validator: checkMobile, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        captchaCode: [
          { required: true, message: "请输入图片验证码", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getCaptchaCode();
  },
  methods: {
    ...mapActions(["setUserInfo","setExpiresTamp"]),
    async getCaptchaCode() {
      const res = await getCaptcha();
      // console.log(res);
      this.form.captchaImg = res.image;
      this.form.captchaKey = res.key;
    },
    getCode(phone, captchaCode) {
      checkMobile(null, phone, (msg) => {
        if (msg) {
          return this.$message.error(msg);
        } else {
          if (!captchaCode) {
            return this.$message.error("图片验证码不能为空");
          } else {
            return this.getSms(phone, this.form.captchaKey, captchaCode);
          }
        }
      });
    },
    async getSms(phone, smsKey, smsCode) {
      // const res = await getSms(phone,smsKey,smsCode);
      // console.log(res);
      // this.$message.success("短信验证码发送成功");
      // this.form.key = res.data;
      // this.countTime();

      getSms(phone, smsKey, smsCode)
        .then((res) => {
          this.$message.success("短信验证码发送成功");
          this.form.key = res.data;
          this.countTime();
        })
        .catch((err) => {
          console.log("验证码错误====", err);
          this.getCaptchaCode();
        });
    },
    countTime() {
      const TIME_COUNT = 60; //倒计时60秒
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.sendDisabled = true;
        this.smsText = this.count + "s后获取";
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.smsText = this.count + "s后获取";
          } else {
            this.sendDisabled = false;
            clearInterval(this.timer);
            this.timer = null;
            this.smsText = "发送验证码";
          }
        }, 1000);
      }
    },
    submit(formName) {
      const { key, code, phone } = this.form;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await loginBySms(key, code, phone);
          // console.log(res);
          this.$message.success("登录成功");
          this.setUserInfo(res);
          let userParams = {
            id: res.user_id,
          };
          let userDetail = await getUserDeatil(userParams);
          res.isCloseSpeak = userDetail.data.isCloseSpeak;

          this.setUserInfo(res);
          console.log("用户详情====",res)
        
          let expiresIn = res.expires_in,
          currDateObj = new Date(),
          currTimeTamp = currDateObj.getTime(),
          expiresInTamp = expiresIn*1000+currTimeTamp;
          this.setExpiresTamp(expiresInTamp);

          if (res.is_tooltip) {
            this.$confirm("是否去设置登录密码？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$router.push({
                  path: "/web/personalCenter",
                  query: {
                    editPwd: 1,
                  },
                });
              })
              .catch(() => {
                this.$router.replace("/web/index");
                // this.$router.go(-1);
              });
          } else {
            setTimeout(() => {
              this.$router.replace("/web/index");
              // this.$router.go(-1);
            }, 500);
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el__form {
  margin-top: 24px;
  .el-input {
    width: 410px;
  }
  /deep/ .captcha__code {
    .el-input-group__append {
      background-color: #ffffff;
    }
    .el-image {
      width: 90px;
    }
  }

  .el__btn {
    width: 410px;
    background: #5cbd31;
    border: 0;
    color: #ffffff;
  }
}
</style>
